// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
Vue.prototype.axios = axios;

import storage from './models/storage'
Vue.prototype.$storage = storage;

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

import Vant from 'vant';
import 'vant/lib/index.css';

import '@vant/touch-emulator';
Vue.use(Vant);

import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard)

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import moment from 'moment';
Vue.prototype.$moment = moment;

import format from 'vue-text-format';
Vue.use(format);

import commonData from './models/commonData';
Vue.prototype.$commonData = commonData;

import commonFormat from './models/commonFormat';
Vue.prototype.$commonFormat = commonFormat;

import numberUtils from './models/numberUtils';
Vue.prototype.$numberUtils = numberUtils;

import dateUtils from './models/dateUtils';
Vue.prototype.$dateUtils = dateUtils;

import bizConfig from './models/bizConfig';
Vue.prototype.$bizConfig = bizConfig;

import router from './router';
Vue.config.productionTip = false;

import fastClick from 'fastclick';
fastClick.attach(document.body);

import ifil from './lib/contract'
Vue.prototype.$ifil = ifil

import coin from './models/coin';
Vue.prototype.$coin = coin;

import bech32 from './models/bech32';
Vue.prototype.$bech32 = bech32;

// IE edge es6 promise finally
// npm install promise.prototype.finally -S 
// main.js
require('promise.prototype.finally').shim();

Vue.prototype.$eventHub = Vue.prototype.$eventHub || new Vue

import store from './store';
import i18n from './i18n.js';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>',
  data: {
    eventHub: new Vue()
  }
})



// WEBPACK FOOTER //
// ./src/main.js